import API from "../../../../../app/api";

export const fetchVideos = async () => {
    const res = await API.get(`/gallery`);

    // API failed (real error)
    if (res.data?.status !== 200) {
        return null;
    }
    return res;

};
